import React, { useContext, useEffect } from "react";
import { connectStateResults } from "react-instantsearch-dom";

import { SearchContext } from "context/providers";

const ResultsContainer = ({ children, searchResults }) => {
  const { setHits } = useContext(SearchContext);

  useEffect(() => {
    setHits(searchResults?.hits || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchResults?.params]);

  return <>{children}</>;
};

export default connectStateResults(ResultsContainer);
